import {useCallback} from 'react';
import {useDispatch} from 'react-redux';

import {updateCandidateProfile} from '../actionCreators';

const useCandidateSaveSectors = candidateId => {
  const dispatch = useDispatch();

  return useCallback(
    sectors =>
      dispatch(
        updateCandidateProfile(candidateId, {
          sectors,
        })
      ),
    [dispatch, candidateId]
  );
};

export default useCandidateSaveSectors;
